import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SortDirection,
  SortField,
} from "../../pages/Campaigns/components/CampaignTable/utils/types";

export type AllCampaignTableState = {
  campaignIdRef: string;
  pageSize: number;
  page: number;
  sortDirection: SortDirection;
  sortField: SortField | null;
};

const initialValues: AllCampaignTableState = {
  campaignIdRef: "",
  pageSize: 10,
  page: 1,
  sortDirection: null,
  sortField: null,
};

export const allCampaignSlice = createSlice({
  name: "allCampaign",
  initialState: initialValues,
  reducers: {
    setCampaignIdRef: (state, action: PayloadAction<string>) => {
      state.campaignIdRef = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSortDirection: (state, action: PayloadAction<SortDirection | null>) => {
      state.sortDirection = action.payload;
    },
    setSortField: (state, action: PayloadAction<SortField | null>) => {
      state.sortField = action.payload;
    },
    resetPagination: (state) => {
      state.page = 1;
      state.pageSize = 10;
    },
  },
});

export const {
  setCampaignIdRef,
  setPageSize,
  setCurrentPage,
  setSortDirection,
  setSortField,
  resetPagination,
} = allCampaignSlice.actions;

export default allCampaignSlice.reducer;
